export const AUTH_ROLES = {
    CASHIER:'cashier',
    BOSS: 'boss',
    SUPER_ADMIN:'superAdmin',
    MANAGER :'manager',
    ADMIN: 'admin'
}